import React, { useEffect, useState } from "react";
import { Box, Button, TextField } from "@mui/material";
import Header from "../../AdminComponents/Header";
import {
  AddPopularLocation,
  ShowAllPopularLocation,
} from "../../../../context/Slice/VendorManagementSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

const BackEnd_URL = process.env.REACT_APP_BASE_URL;

const ViewPopularLocation = ({ handleFormClose, id}) => {
  const dispatch = useDispatch();
  const Location = useSelector((state) => state.VendorManagementR.AllLoc || []);
  const [selectedImage, setSelectedImage] = useState(null);
  const [data, setData] = useState({});
  const [formData, setFormData] = useState({
    LocationName: "",
    Images: [],
    Description: "",
  });

  // Fetch Service Location Data
  useEffect(() => {
    dispatch(ShowAllPopularLocation());
  }, [dispatch]);

  useEffect(() => {
    if (Location.length > 0) {
      const filteredData = Location.find((item) => item.id === id);
      if (filteredData) {
        setData(filteredData);
        setFormData({
          LocationName: filteredData.LocationName || "",
          Images: filteredData.Images || [],
          Description: filteredData.Descriptions || "",
        });
        setSelectedImage(filteredData.Images.map(img => `${BackEnd_URL}${img.path}`));
      }
    }
  }, [Location, id]);


  console.log(selectedImage)
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleImagePreview = (event) => {
    const files = Array.from(event.target.files); // Convert FileList to Array
    if (files.length > 0) {
      setSelectedImage(files.map((file) => URL.createObjectURL(file)));
      setFormData((prev) => ({
        ...prev,
        Images: files, // Store actual File objects
      }));
    }
  };


  

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
    
  //   const formDataToSend = new FormData();
  //   formDataToSend.append("id", Number(data.id));
  //   formDataToSend.append("LocationName", formData.LocationName);
  //   formDataToSend.append("Descriptions", formData.Description);
    
  //   // Append each image file
  //   // formData.Images.forEach((image) => {
  //   //   formDataToSend.append("Images", image); 
  //   // });
  
  //   try {
  //     await dispatch(updateServiceLocation(formDataToSend)).unwrap();
  //     toast.success("Service location updated successfully");
  //   } catch (error) {
  //     toast.error(error || "Failed to update service location");
  //   }
  // };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const updatedData = {
      id: Number(data.id),
      LocationName: formData.LocationName,
      Images: formData.Images, 
      Descriptions: formData.Description,
    };

    try {
      await dispatch(AddPopularLocation(updatedData)).unwrap();
      toast.success("Service location updated successfully");
    } catch (error) {
      toast.error(error || "Failed to update service location");
    }
  };
  return (
    <Box m="20px">
      <Header title="View Location" subtitle="View and Edit Location Details" />

      <form autoComplete="off" onSubmit={handleSubmit}>
        <Box display="flex" gap="30px">
          <Box display="flex" flexDirection="column" flex="1" gap="20px">
            <TextField
              fullWidth
              variant="filled"
              type="text"
              label="Location Name"
              name="LocationName"
              value={formData.LocationName}
              onChange={handleInputChange}
            />

            <TextField
              fullWidth
              variant="filled"
              type="file"
              label="Upload Images"
              name="Images"
              InputLabelProps={{ shrink: true, style: { fontSize: 15 } }}
              inputProps={{ multiple: true }} // ✅ Enables multiple file selection
              onChange={handleImagePreview}
            />
          </Box>

          <Box flex="1" display="flex" flexWrap="wrap" gap="10px">
              {selectedImage &&
                selectedImage.map((imageUrl, index) => (
                  <img
                    key={index}
                    src={imageUrl}
                    alt="Location Preview"
                    style={{
                      width: "120px",
                      height: "auto",
                      borderRadius: "10px",
                      marginRight: "10px",
                    }}
                  />
                ))}
          </Box>
        </Box>

        <Box mt="26px" width={"70%"}>
          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="Description"
            name="Description"
            value={formData.Description}
            multiline
            rows={6}
            inputProps={{ style: { marginTop: "15px" } }}
            onChange={handleInputChange}
          />
        </Box>

        <Box display="flex" justifyContent="center" mt="50px">
          <Button
            type="submit"
            variant="contained"
            className="primary fs-4"
            sx={{ mr: 2 }}
          >
            Save
          </Button>
          <Button
            type="button"
            variant="contained"
            className="primary fs-4"
            onClick={handleFormClose}
          >
            Back
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default ViewPopularLocation;
